import React from 'react'
import DefaultOutput from './MobileDefaultOutput'
import useConsoleStore from '../../stores/ConsoleStore'

function MobileConsole() {
  const {outputs, switchChannel, fetchConsole, selectedChannel} = useConsoleStore()
  const console_btns = ['all', 'summary', 'trades', 'triggers', 'exec', 'error']
  console.log('CONSOLE', outputs)
  const changeChannel = e => {
    e.preventDefault();
    const channel = e.target.name
    switchChannel(channel)
    fetchConsole()
  }

  return (
    <div className="mobile_container">
    <div className="mobile_console_btn_container">
        {console_btns.map((btn) => {
            return <button key={btn} name={btn} className={btn === selectedChannel ? "console_btn active_console btn no_drag" : "console_btn btn no_drag"} onClick={changeChannel}>{btn}</button>
        })}
    </div>                    
    { 
      (selectedChannel in outputs) ?  
      (<ul className="mombile_console_ul" id ='console_ul' key={selectedChannel + "console"}> {
          outputs[selectedChannel].map((alerts) => {
              return <DefaultOutput key={JSON.stringify(alerts)} props={alerts}/>}
              )} </ul>) : (
                  <ul></ul>
              )
    }
</div>
  )
}

export default MobileConsole